import layoutHeaderAside from '@/layouts/HeaderAside'
const meta = { auth: true }
export default {
  path: '/',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/pages/Index/page.vue'),
      meta: {
        ...meta,
        title: '首页'
      }
    },
  ]
}
